import React from "react";
// import ApexCharts from "react-apexcharts";
import ReactApexChart from "react-apexcharts";
import getChartDefultOption from "../../utils/getChartDefultOption";
const AnalyticsChart = ({ series, categories }) => {
  const customColors = [
    'var(--color-chart-1)',
    'var(--color-chart-0)',
  ]  

  const options = getChartDefultOption({
    id: "chart--RatingChart",
    categories,
    distributed: true, 
    customColors,
    columnWidth: 72
  });
  
  return (
    <div style={{marginBottom: "-15px"}}>
      <div id="chart--RatingChart">
        <ReactApexChart options={options} series={series} type="bar" height={211} />
      </div>
    </div>
  );
};

export default AnalyticsChart;
